/* ============================================================
   assets/samsons-blog.js
   Samson's Haircare — shoppable blog behavior

   Three jobs, nothing else:
     1. The mobile sticky bar: on after 20% of the post, off once the two
        doors are in view, so nobody is asked twice on one screen.
     2. Zone attribution: dataLayer events into GTM-PF6S8FRL so you can see
        which zone of the page actually moves people. No UTM parameters on
        internal links, they would break GA4 session attribution.
     3. Add to cart the way this theme does it everywhere else: fetch
        /cart/add.js, refresh the header count, stay on the page. No
        redirect to /cart. Steps aside if a <product-form> element exists.

   Loaded by sections/main-article.liquid, on shoppable posts only.
   ============================================================ */

(function () {
  'use strict';

  var bar     = document.getElementById('sb-bar');
  var doors   = document.querySelector('.sb-doors');
  var article = document.querySelector('.article-body-wrap');
  var host    = document.querySelector('[data-sb-article]');
  var handle  = host ? (host.getAttribute('data-sb-article') || '').trim() : '';
  var mode    = host ? (host.getAttribute('data-sb-mode') || 'post') : 'post';   // post | default

  /* ---------- dataLayer ------------------------------------ */
  function push(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = params || {};
      o.event = name;
      o.article_handle = handle || window.location.pathname;
      o.rail_mode = mode;   // 'post' = editorial rail_products, 'default' = store best sellers
      window.dataLayer.push(o);
    } catch (e) { /* tracking must never break the page */ }
  }

  function zoneOf(el) {
    var host = el.closest('[data-sb-zone]');
    return host ? (host.getAttribute('data-sb-zone') || 'unknown') : 'unknown';
  }

  /* ---------- 1. Sticky bar -------------------------------- */
  if (bar) {
    bar.hidden = false;

    var doorsInView = false;
    var ticking = false;

    function evaluate() {
      ticking = false;
      var d = document.documentElement;
      var scrollable = Math.max(d.scrollHeight - window.innerHeight, 1);
      var pct = (window.pageYOffset || d.scrollTop) / scrollable;
      var on = pct > 0.2 && !doorsInView;
      bar.classList.toggle('is-on', on);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluate);
    }

    if (doors && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        doorsInView = entries[0].isIntersecting;
        evaluate();
      }, { rootMargin: '0px 0px -15% 0px', threshold: 0 }).observe(doors);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    evaluate();
  }

  /* ---------- 2. Zone attribution -------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var quiz = t.closest('[data-ffq="open"]');
    if (quiz) {
      push('sb_quiz_open', { zone: zoneOf(quiz) });
      return;
    }

    var add = t.closest('[data-sb-add]');
    if (add) {
      push('sb_add_to_cart', {
        zone: add.getAttribute('data-sb-zone') || zoneOf(add),
        product_handle: add.getAttribute('data-sb-handle') || '',
        item_name: add.getAttribute('data-sb-title') || '',
        value: parseFloat(add.getAttribute('data-sb-price') || '0') || 0,
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      });
      return;
    }

    var link = t.closest('.sb-card__title, .sb-card__img, .sb-lnk');
    if (link) {
      push('sb_zone_click', {
        zone: zoneOf(link),
        product_handle: (link.closest('[data-sb-handle]') || {}).getAttribute
          ? link.closest('[data-sb-handle]').getAttribute('data-sb-handle')
          : ''
      });
    }
  }, true);

  /* ---------- 3. Add to cart ------------------------------- */
  /* This theme (Samsons Redesign 2026) has no Dawn cart drawer and no
     <product-form> element on the article template. Its own product cards
     add to cart in assets/main.js like this: POST /cart/add.js, then GET
     /cart.js, update the "Cart (n)" text in the header, fire a
     'cart:updated' event, and show "Added" on the button. The reader stays
     on the page. This block does exactly the same for the blog forms, so the
     add behaves like everywhere else on the site and nobody is thrown to
     /cart mid-read. If a future theme registers <product-form>, this block
     steps aside and lets it handle the add. */

  function themeHasProductForm() {
    return !!(window.customElements && window.customElements.get('product-form'));
  }

  function setCartCount(count) {
    document.querySelectorAll('.nav-cart, .nav-drawer-cart').forEach(function (el) {
      el.textContent = 'Cart (' + count + ')';
    });
    var mobile = document.querySelector('.nav-mobile-cart');
    if (mobile) {
      var badge = mobile.querySelector('.nav-mobile-cart-count');
      if (!badge && count > 0) {
        badge = document.createElement('span');
        badge.className = 'nav-mobile-cart-count';
        mobile.appendChild(badge);
      }
      if (badge) badge.textContent = count;
      mobile.setAttribute('aria-label', 'Cart, ' + count + ' items');
    }
  }

  function addToCart(form, button) {
    var addUrl  = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    var cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    var label   = button.querySelector('.sb-btn__label');
    var orig    = label ? label.textContent : '';

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) {
          throw new Error((res.data && (res.data.description || res.data.message)) || 'Could not add that.');
        }
        return fetch(cartUrl, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        if (cart && typeof cart.item_count === 'number') {
          setCartCount(cart.item_count);
          try { window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); } catch (e) {}
        }
        button.classList.add('is-done');
        if (label) label.textContent = 'Added';
        setTimeout(function () {
          button.classList.remove('is-done');
          if (label) label.textContent = orig;
        }, 1800);
      })
      .catch(function (err) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        showError(form, (err && err.message) || 'Could not add that.');
      });
  }

  function showError(form, msg) {
    var wrap = form.querySelector('.sb-atc__err');
    if (!wrap) return;
    var span = wrap.querySelector('.product-form__error-message');
    if (span) span.textContent = msg;
    wrap.hidden = false;
  }

  function bindFallback() {
    if (themeHasProductForm()) return;
    document.querySelectorAll('[data-sb-atc] form').forEach(function (form) {
      if (form._sbBound) return;
      form._sbBound = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var button = form.querySelector('[data-sb-add]');
        if (!button) { form.submit(); return; }
        addToCart(form, button);
      });
    });
  }

  /* Bind as soon as the DOM is ready (the script is deferred, so usually
     right now). No delay: a click that lands before binding would submit
     the form natively and send the reader to /cart. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindFallback);
  } else {
    bindFallback();
  }
}());
